/* Core by Chloe Pilates — Our Story */
(function(){
  if (customElements.get('cbc-story')) return;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  class CbcStory extends HTMLElement {
    connectedCallback(){
      if (this._init) return; this._init = true;
      const $$ = (s) => Array.from(this.querySelectorAll(s));

      // reveal on enter
      const io = new IntersectionObserver((entries) => {
        entries.forEach(e => { if (e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); } });
      }, {rootMargin: '0px 0px -12% 0px', threshold: 0.08});
      $$('.cbs-reveal, .cbs-unmask').forEach(el => reduce ? el.classList.add('is-in') : io.observe(el));

      // anatomy hotspots
      $$('[data-anatomy]').forEach(sec => {
        const set = (n) => {
          sec.querySelectorAll('[data-spot]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.spot === n)));
          sec.querySelectorAll('[data-item]').forEach(li => li.classList.toggle('is-active', li.dataset.item === n));
        };
        sec.querySelectorAll('[data-spot]').forEach(b => b.addEventListener('click', () => set(b.dataset.spot)));
        const first = sec.querySelector('[data-spot]'); if (first) set(first.dataset.spot);
      });

      // drag to scroll the collection strip on desktop
      $$('[data-drag]').forEach(strip => {
        let down = false, sx = 0, sl = 0, moved = 0;
        strip.addEventListener('pointerdown', e => { if (e.pointerType !== 'mouse') return; down = true; moved = 0; sx = e.clientX; sl = strip.scrollLeft; });
        window.addEventListener('pointermove', e => { if (!down) return; const dx = e.clientX - sx; moved = Math.max(moved, Math.abs(dx)); if (moved > 6) strip.classList.add('is-drag'); strip.scrollLeft = sl - dx; });
        window.addEventListener('pointerup', () => { if (!down) return; down = false; setTimeout(() => strip.classList.remove('is-drag'), 0); });
        strip.addEventListener('click', e => { if (moved > 6) e.preventDefault(); }, true);
      });

      this.plx = $$('[data-parallax]');
      this.quotes = $$('[data-words]').map(p => ({el: p, words: Array.from(p.querySelectorAll('.cbs-qw'))}));
      this.philos = $$('[data-philo]').map(s => ({el: s, words: Array.from(s.querySelectorAll('.cbs-pw'))}));
      this.chapters = $$('[data-chapter]');
      this.rail = this.querySelector('[data-rail]');
      if (this.rail){
        this.springs = this.rail.querySelector('[data-springs]');
        this.carriage = this.rail.querySelector('[data-carriage]');
        this.label = this.rail.querySelector('[data-rail-label]');
      }
      if (reduce){ this.philos.forEach(p => p.el.classList.add('is-done')); this.quotes.forEach(q => q.words.forEach(w => w.classList.add('on'))); }

      const onScroll = () => { if (this._raf) return; this._raf = requestAnimationFrame(() => { this._raf = 0; this.update(); }); };
      window.addEventListener('scroll', onScroll, {passive: true});
      window.addEventListener('resize', onScroll);
      this.update();
    }

    update(){
      const vh = window.innerHeight, vw = window.innerWidth;

      if (!reduce){
        // gentle parallax
        this.plx.forEach(el => {
          const r = el.getBoundingClientRect();
          if (r.bottom < -200 || r.top > vh + 200) return;
          const k = parseFloat(el.dataset.parallax) || 0;
          const off = (r.top + r.height / 2 - vh / 2) * k;
          el.style.transform = 'translate3d(0,' + off.toFixed(1) + 'px,0)';
        });

        // quote words light up as the line passes through the screen
        this.quotes.forEach(q => {
          const r = q.el.getBoundingClientRect();
          const p = Math.min(1, Math.max(0, (vh * 0.85 - r.top) / (vh * 0.85 - vh * 0.3 + r.height * 0.6)));
          const n = Math.round(p * q.words.length);
          q.words.forEach((w, i) => w.classList.toggle('on', i < n));
        });

        // philosophy: one word comes into focus at a time
        this.philos.forEach(ph => {
          const r = ph.el.getBoundingClientRect();
          const span = r.height - vh;
          const p = Math.min(1, Math.max(0, -r.top / Math.max(1, span)));
          const n = ph.words.length;
          ph.words.forEach((w, i) => w.classList.toggle('on', p > (i + 0.15) / (n + 0.6)));
          ph.el.classList.toggle('is-done', p > (n - 0.1) / (n + 0.6));
        });
      }

      // reformer carriage rail
      if (this.rail){
        const r = this.getBoundingClientRect();
        const total = r.height - vh;
        const p = Math.min(1, Math.max(0, -r.top / Math.max(1, total)));
        const first = this.chapters[0];
        const pastIntro = first ? first.getBoundingClientRect().bottom < vh * 0.6 : true;
        const on = pastIntro && r.bottom > vh * 0.9;
        this.rail.classList.toggle('is-on', on);
        const x = 44 + p * (vw - 44);
        this.carriage.style.left = x + 'px';
        this.springs.style.width = Math.max(0, x - 44) + 'px';
        let cur = null;
        this.chapters.forEach(c => { const cr = c.getBoundingClientRect(); if (cr.top < vh * 0.55) cur = c; });
        if (cur && this.label){
          const name = cur.dataset.chapter || '';
          if (this.label.textContent !== name) this.label.textContent = name;
          this.label.style.left = Math.min(vw - 90, Math.max(90, x - 22)) + 'px';
          this.rail.classList.toggle('on-deep', cur.hasAttribute('data-philo') && cur.getBoundingClientRect().bottom > vh);
        }
      }
    }
  }
  customElements.define('cbc-story', CbcStory);
})();
